const SyncingPromise = require('../syncing-promise')

function API({
  $window,
  $location,
  apiRoot,
  sync,
}) {
  return {
    get: (pathname) => APIEndpoint('GET', pathname),
    post: (pathname) => APIEndpoint('POST', pathname),
  }

  function APIEndpoint(method, pathname) {
    method = method.toUpperCase()
    return function makeRequest(params = {}, {
      redirectOn401 = true,
    } = {}) {
      let url = apiRoot + pathname
      const opts = {
        credentials: 'include',
        method,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        mode: 'cors',
      }

      if (method === 'POST') {
        opts.body = JSON.stringify(params)
      } else if (method === 'GET') {
        const query = new $window.URLSearchParams(params).toString()
        if (query) {
          url += '?' + query
        }
      }

      sync()
      return SyncingPromise(sync, new $window.Promise(function(resolve, reject) {
        $window.fetch(url, opts)
          .catch(err => {
            $window.console.error(err)
            reject({
              body: {
                message: 'A network error occurred. Please check your internet connection and try again.',
              }
            })
            return null
          })
          .then(res => {
            if (res === null) {
              return // i.e. we caught a network error and rejected

            } else if (res.status === 204) {
              return resolve({ status: res.status })

            } else if (res.ok) {
              return res.json().then(body => resolve({
                body,
                status: res.status,
              }))

            } else if (res.status === 400) {
              return res.json().then(({ detail }) => reject({
                status: res.status,
                body: {
                  message: 'There were problems with your submission',
                  fieldErrors: detail,
                }
              }))
            } else if (res.status === 401 && redirectOn401) {
              const { href, origin } = $location
              $location.href = `${origin}/auth/sign-in/#dest=${encodeURIComponent(href)}`
              return

            } else {
              return res.json().then(body => reject({
                body,
                status: res.status,
              }))
            }
          })
          .catch(reject)
      }))
    }
  }
}

module.exports = API
